/* eslint-disable no-alert */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable global-require */
import React, { useState, useEffect } from 'react';
import { Typography, CssBaseline, Box, Button, Avatar, Modal, Backdrop, Grid, IconButton, TextField, CircularProgress } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useNavigate } from 'react-router-dom';
import { ROUTE_PATHS } from 'app/utils/route';
import { useIsLoggedIn } from 'auth/useAuth';
import { useDispatch, useSelector } from 'react-redux';
import {
    signInAsync,
    // getGeneralSettings,
    getTokenByUsername,
    verifyCaptcha,
    getCaptcha,
} from 'redux/auth/authActions';
import { errorHandler } from 'utils/errorHandler';
import { liscenseExpired } from 'utils/constants';
import { getFromSession, removeFromSession } from 'utils/storage';
import { setCopyright, clearAuthSource } from 'redux/auth/authSlice';
import { yellow } from '@mui/material/colors';
import { useMsal } from '@azure/msal-react';
import {  generateHash } from 'utils/encryptDecrypt';
import { useCommonInits } from 'hooks/useCommonInits';
import CloseIcon from '@mui/icons-material/Close';
import RefreshIcon from '@mui/icons-material/Refresh';
import { LoginTextField } from './LoginTextField';
import { loginRequest } from '../authConfig';

const useStyles = makeStyles(theme => ({
    loginContainer: {
        [theme.breakpoints.down('sm')]: {
            width: '100%!important',
        },
    },
}));

export default function SignIn() {
    const { instance } = useMsal();

    // const logoURL = require('assets/images/brand_logo.png');
    const backgroundUrl = require('assets/images/background-analytics.jpg');
    const defaultBgUrl = require('assets/images/background-analytics.jpg');
    const defaultLogo = require('assets/images/ioagpl.png');
    const poweredByLogo = require('assets/images/brand_logo.png');
    const captchaBackground = require('assets/images/captchaBackground.jpeg');
    const navigate = useNavigate();
    const isSignedIn = useIsLoggedIn();
    const dispatch = useDispatch();
    const {translate} = useCommonInits();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState({});
    const classes = useStyles();
    const [openVerify, setOpenVerify] = useState(false);
    const [otp, setOtp] = useState('');
    const [enteredCaptcha, setEnteredCaptcha] = useState(null);
    const captchaDetails = useSelector(
        state => state?.auth?.captchaDetails,
    );
    const [isValid, setIsValid] = useState(true);
    const [isLoading, setIsLoading] = useState(false);

    const handleNavigation = () => {
        // const prevRoute = location.state?.from;
        // if (prevRoute) {
        //     navigate(prevRoute.pathname);
        // } else {
            // if(user.user_role === 'APCM_Admin'){
                navigate(`/${ROUTE_PATHS.apcmDashboard}`);

        //     }else{ navigate(`/${ROUTE_PATHS.home}`);
        // }
        
        // }
    };

    const handleCaptchaRefresh = () => {
        dispatch(getCaptcha());
        setEnteredCaptcha(null);
    };

    const handleSubmit = event => {
        event?.preventDefault();
        setError({
            email: !email.length,
            password: !password.length,
            enteredCaptcha: !enteredCaptcha.length,
        });

        if (email.length && password.length && enteredCaptcha.length) {
            setIsLoading(true);
            dispatch(
                verifyCaptcha({
                    captcha: enteredCaptcha,
                    email,
                    password: generateHash(password),
                    captchaId: captchaDetails?.captchaId,
                }),
            ).then(response => {
                setIsLoading(false);
                if (response?.payload?.status === 'success') {
                    setOpenVerify(true);
                } else {
                    handleCaptchaRefresh();
                    setOpenVerify(false);
                }
            });
        }
    };

    const loginToApp = () => {
        if (otp.length) {
            dispatch(signInAsync({credentials: { email, password: generateHash(password), otp }}));
        }
    }

    const loginWithMicrosoft = () => {
        instance
            .loginPopup(loginRequest)
            .then(response => {
                if (response.account.username) {
                    dispatch(
                        getTokenByUsername({
                            email: response.account.username,
                            username: generateHash('Admin'),
                            password: generateHash('Admin@123'),
                            accessToken: response?.accessToken
                        }),
                    );
                }
            })
            .catch(e => {
                alert(e);
            });

        // instance.loginPopup(loginRequest).catch((e) => {
        //   alert(e);
        // });
    };

    const checkValidityMessage = () => {
        const isLiscenseExpired = JSON.parse(getFromSession(liscenseExpired));
        if (isLiscenseExpired) {
            errorHandler(dispatch, { message: 'Your liscense is expired!' });
            removeFromSession(liscenseExpired);
        }
    };

    // const fetchGeneralSettings = () => {
    //     dispatch(getGeneralSettings());
    // };

    useEffect(() => {
        dispatch(clearAuthSource())
        checkValidityMessage();
        // fetchGeneralSettings();
        dispatch(getCaptcha());
    }, []);

    useEffect(() => {
        if (error.email || error.password) {
            setError({
                email: !email.length,
                password: !password.length,
            });
        }
    }, [email, password]);

    useEffect(() => {
        dispatch(setCopyright(false));
        if (isSignedIn) {
            handleNavigation();
            dispatch(setCopyright(true));
        }
    }, [isSignedIn]);


    const handleClose = () => {
        setOtp('');
        handleCaptchaRefresh();
        setOpenVerify(false);
    }

    const handleInputChange = (event) => {
        const value = event.target.value;
        const numberPattern = /^[0-9]*$/;
    
        if (numberPattern.test(value) || value === '') {
          setOtp(value);
          setIsValid(true);
        } else {
          setIsValid(false);
        }
      };

    const rendorVerifyOtp = () => (
        <div>
            <Modal
                aria-labelledby="spring-modal-title"
                aria-describedby="spring-modal-description"
                open={openVerify}
                onClose={handleClose}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
            >
                <Box sx={styles.saveModal}>
                    <Grid container>
                        <Grid item xs={10}>
                            <Typography
                                id="spring-modal-title"
                                variant="h6"
                                component="h2"
                            >
                                {translate('verifyOtp')}
                            </Typography>
                        </Grid>
                        <Grid item sx={styles.closeIcon}>
                            <IconButton onClick={handleClose}>
                                <CloseIcon />
                            </IconButton>
                        </Grid>
                    </Grid>

                    <TextField
                        id="outlined-basic"
                        required
                        label={translate('OTP')}
                        variant="outlined"
                        size="small"
                        fullWidth
                        value={otp}
                        error={!isValid}
                        helperText={!isValid ? 'Please enter a valid OTP (only digits 0-9)' : ''}
                        inputProps={{ maxLength: 7, pattern:"[0-9]*" }}
                        onChange={handleInputChange}
                        sx={{ marginTop: 2, marginBottom: 2 }}
                        
                    />

                    <Grid item sx={styles.controlsContainer}>
                        
                            <Button
                                variant="contained"
                                sx={styles.controlButtons}
                                onClick={loginToApp}
                            >
                                {translate('submit')}
                            </Button>
                    </Grid>
                </Box>
            </Modal>
        </div>
    )

    return (
        <>
            <CssBaseline />
            <Box
                component="div"
                sx={styles.container}
                style={{ backgroundImage: `url(${backgroundUrl})` }}
                onError={({ currentTarget }) => {
                    currentTarget.onerror = null;
                    currentTarget.style.backgroundImage = `url(${defaultBgUrl})`;
                }}
            >
                <Box
                    sx={styles.formBoxStyle}
                    className={classes.loginContainer}
                >
                    <Avatar sx={styles.logoWrapper}>
                        <img
                            alt="Avatar"
                            src={defaultLogo}
                            style={styles.logo}
                            onError={({ currentTarget }) => {
                                currentTarget.onerror = null;
                                currentTarget.src = defaultLogo;
                                currentTarget.style = '';
                            }}
                        />
                    </Avatar>
                    <Typography variant="h6" sx={styles.lightColor}>
                         Welcome to APCM
                    </Typography>
                    <Box
                        component="form"
                        onSubmit={handleSubmit}
                        noValidate
                        sx={{ mt: '-7px' }}
                    >
                        <LoginTextField
                            margin="normal"
                            required
                            fullWidth
                            id="email"
                            label="Username"
                            name="email"
                            autoComplete="email"
                            autoFocus
                            value={email}
                            onChange={e => setEmail(e.target.value)}
                            error={error.email}
                        />
                        <LoginTextField
                            margin="normal"
                            required
                            fullWidth
                            name="password"
                            label="Password"
                            type="password"
                            id="password"
                            autoComplete="current-password"
                            value={password}
                            onChange={e => setPassword(e.target.value)}
                            error={error.password}
                        />

                        <Grid container spacing={2} sx={{ alignItems: 'center' }}>
                            <Grid item xs={12} sm={6}>
                                <Box sx={[styles?.captchBox, {display: 'flex', backgroundColor: '#f3f3f3',}]}>
                                    <Box >
                                        <Typography
                                            id="spring-modal-title"
                                            variant="h6"
                                            component="h6"
                                            sx={[styles?.captchView, { backgroundImage: `url(${captchaBackground})`}]}
                                        >
                                            {captchaDetails?.captcha}
                                        </Typography>
                                    </Box>
                                    <IconButton
                                        aria-label="refresh captcha"
                                        sx={styles?.captchaRefresh}
                                        onClick={handleCaptchaRefresh}
                                    >
                                        <RefreshIcon />
                                    </IconButton>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Box sx={{ height: '80px' }}>
                                    <LoginTextField
                                        margin="normal"
                                        required
                                        fullWidth
                                        id="captcha"
                                        label="Enter Captcha"
                                        name="captcha"
                                        sx={{height: '16px'}}
                                        autoFocus
                                        onChange={e =>
                                            setEnteredCaptcha(e.target.value)
                                        }
                                        error={error.enteredCaptcha}
                                    />
                                </Box>
                            </Grid>
                        </Grid>
                        
                        {isLoading ? (
                            <CircularProgress
                                size="50px"
                                style={{ marginLeft: '130px' }}
                            />
                        ) : null}
                        <Button
                            type="submit"
                            fullWidth
                            variant="outlined"
                            sx={{
                                mt: 1,
                                mb: 1,
                                color: 'white',
                                border: '1px solid',
                                '&:hover': {
                                    borderColor: yellow[900],
                                    color: yellow[900],
                                },
                            }}
                        >
                            Sign In
                        </Button>
                        <Button
                            type="button"
                            fullWidth
                            variant="outlined"
                            onClick={loginWithMicrosoft}
                            sx={{
                                mt: 0.5,
                                mb: 1,
                                color: 'white',
                                border: '1px solid',
                                '&:hover': {
                                    borderColor: yellow[900],
                                    color: yellow[900],
                                },
                            }}
                        >
                            <img
                                src="/static/images/microsoft.png"
                                style={{ width: '10%', paddingRight: '3%' }}
                            />
                            Sign In With Microsoft
                        </Button>

                        <Box sx={styles.poweredByWrapper}>
                            <Typography variant="p" sx={styles.poweredByText}>
                                Powered By
                            </Typography>
                            <img
                                src={poweredByLogo}
                                style={styles.poweredByLogo}
                                alt="powered by logo"
                            />
                        </Box>
                    </Box>
                </Box>
                { openVerify && rendorVerifyOtp()}
            </Box>
        </>
    );
}

const styles = {
    container: {
        display: 'flex',
        height: '100vh',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
    },
    formBoxStyle: {
        position: 'absolute',
        margin: 'auto',
        top: 0,
        left: '90px',
        bottom: 0,
        height: '560px',
        width: '350px',
        padding: '11px',
        boxShadow: '0 0 4px grey',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        background: 'rgb(0, 0, 0, 0.7)',
        borderRadius: '25px',
        backgroundImage: 'linear-gradient(140deg, #3f674a 30%, #1c2b56 50%, #1c2b56 75%);',
        opacity: '0.9',
    },
    lightColor: {
        color: '#fff',
    },
    logoWrapper: {
        m: 1,
        bgcolor: 'transparent',
        width: '100%',
        height: 'fit-content',
        borderRadius: 'unset',
    },
    logo: {
        width: '40%',
        height: '100%',
    },
    poweredByText: {
        paddingTop: 0.5,
        paddingRight: 1,
    },
    poweredByWrapper: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    poweredByLogo: {
        width: 100,
        background: 'white',
        borderRadius: 5,
    },
    captchBox: {
        marginTop: '4px',
        height: '100%',
        userSelect: 'none',
    },
    captchView: {
        letterSpacing: '0.05em', 
        fontWeight: 'bolder', 
        fontSize: '30px', 
        color: 'black', 
        fontFamily: 'Courier New', 
        backgroundSize: 'cover', 
        userSelect: 'none',
        WebkitUserSelect: 'none',
        MozUserSelect: 'none',
        msUserSelect: 'none',
    },
    captchaRefresh: { outline: 'none !important', color: 'black'},
    saveModal: {
        position: 'absolute',
        top: '13%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 300,
        bgcolor: 'background.default',
        border: '1px solid',
        boxShadow: 24,
        p: 2,
    },
    controlsContainer: { display: 'flex', justifyContent: 'center' },
    controlButtons: { mt: 2, mr: 2 },
    closeIcon: {
        position: 'absolute',
        right: '5px',
        top: '5px',
    },
};
